import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoayodhyatourpackage() {



const cardData = {
  keyword: " Pune to Ayodhya Tour Package  ",

"headingDescription": "Pune to Ayodhya Tour Package is thoughtfully designed for devotees and travelers seeking a comfortable and well-organized journey to one of India’s most sacred cities. SRS Cab Service offers end-to-end travel solutions with experienced drivers, clean vehicles, and flexible itineraries tailored for spiritual tours. Whether you are planning a family pilgrimage or a group visit, this package ensures a peaceful and convenient experience with transparent pricing, planned stops, and dedicated support throughout the trip. Travel from Pune to Ayodhya with ease and focus entirely on your spiritual journey.",
"topPlaces": [
  {
    "title": "Ram Janmabhoomi",
    "description": "Ram Janmabhoomi is the most revered site in Ayodhya, believed to be the birthplace of Lord Ram. Travelers booking Pune to Ayodhya Tour Package visit this sacred place to offer prayers and experience deep spiritual significance."
  },
  {
    "title": "Hanuman Garhi",
    "description": "Hanuman Garhi is a famous temple dedicated to Lord Hanuman, located on a hilltop in Ayodhya. Visitors using Pune to Ayodhya Tour Package climb the steps to seek blessings and enjoy views of the city."
  },
  {
    "title": "Kanak Bhawan",
    "description": "Kanak Bhawan is a beautiful temple dedicated to Lord Ram and Goddess Sita. Travelers using Pune to Ayodhya Tour Package admire its architecture and peaceful devotional atmosphere."
  },
  {
    "title": "Saryu River Ghat",
    "description": "Saryu River Ghat is a sacred place where devotees take holy dips and attend evening aarti. Visitors booking Pune to Ayodhya Tour Package experience spiritual peace and cultural rituals here."
  },
  {
    "title": "Treta Ke Thakur",
    "description": "Treta Ke Thakur Temple is believed to be associated with Lord Ram’s Ashwamedha Yagna. Travelers using Pune to Ayodhya Tour Package visit this temple for its historical and religious importance."
  },
  {
    "title": "Nageshwarnath Temple",
    "description": "Nageshwarnath Temple is an ancient temple dedicated to Lord Shiva in Ayodhya. Visitors using Pune to Ayodhya Tour Package include this site for a complete spiritual journey."
  },
  {
    "title": "Guptar Ghat",
    "description": "Guptar Ghat is a peaceful and sacred location on the banks of the Saryu River. Travelers booking Pune to Ayodhya Tour Package visit this place for calm surroundings and spiritual reflection."
  },
  {
    "title": "Mani Parvat",
    "description": "Mani Parvat is a small hill with mythological significance linked to the Ramayana. Visitors using Pune to Ayodhya Tour Package explore this site for its views and historical importance."
  },
  {
    "title": "Ramkatha Park",
    "description": "Ramkatha Park is a cultural space hosting religious events and performances. Travelers using Pune to Ayodhya Tour Package enjoy spiritual programs and peaceful surroundings here."
  },
  {
    "title": "Tulsi Smarak Bhawan",
    "description": "Tulsi Smarak Bhawan is dedicated to Goswami Tulsidas, the author of Ramcharitmanas. Visitors using Pune to Ayodhya Tour Package explore this place to learn about devotional literature and history."
  }
],



services: [
{
name: "Pune to Ayodhya Cab",
description: "Pune to Ayodhya cab service offers reliable long-distance travel for pilgrimage trips. Customers can book cabs for comfortable journeys to Ram Mandir. Professional drivers ensure safe highway travel. Comfortable vehicles enhance long-distance experience. Flexible booking options are available. Travel easily from Pune to Ayodhya with cab services."
},
{
name: "Pune to Ayodhya Tour Package",
description: "Pune to Ayodhya tour package provides complete travel solutions for devotees. Customers can choose multi-day packages for temple visits. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe travel. Transparent pricing ensures value for money. Book Ayodhya tour packages from Pune easily."
},
{
name: "Pune to Ayodhya Cab Package",
description: "Pune to Ayodhya cab package offers organized travel for long-distance trips. Customers can enjoy planned journeys with private vehicles. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab packages from Pune."
},
{
name: "Pune to Ayodhya Taxi Package",
description: "Pune to Ayodhya taxi package provides convenient travel options for pilgrims. Customers can book taxis with customized itineraries. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures affordability. Choose taxi packages for Ayodhya travel."
},
{
name: "Pune to Ayodhya Tour by Cab",
description: "Pune to Ayodhya tour by cab offers personalized travel for temple visits. Customers can enjoy flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel conveniently with cab tours from Pune."
},
{
name: "Pune to Ayodhya Travel Package",
description: "Pune to Ayodhya travel package offers complete trip planning for long-distance travel. Customers can explore Ayodhya comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures value for money. Book travel packages from Pune to Ayodhya easily."
},
{
name: "Pune to Ayodhya Darshan Package",
description: "Pune to Ayodhya darshan package provides dedicated travel for temple visits. Customers can enjoy hassle-free darshan trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily with darshan packages from Pune."
},
{
name: "Pune to Ayodhya Ram Mandir Tour Package",
description: "Pune to Ayodhya Ram Mandir tour package offers complete travel for visiting the holy temple. Customers can enjoy guided pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Ram Mandir from Pune."
},
{
name: "Pune to Ayodhya Cab Service",
description: "Pune to Ayodhya cab service provides reliable long-distance transportation. Customers can book cabs for business or pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily with cab services from Pune."
},
{
name: "Pune to Ayodhya Taxi Service",
description: "Pune to Ayodhya taxi service offers convenient transportation for long journeys. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily from Pune to Ayodhya."
},
{
name: "Pune to Ayodhya Cab Booking",
description: "Pune to Ayodhya cab booking provides quick and easy reservation options. Customers can book cabs online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your Pune to Ayodhya cab easily."
},
{
name: "Pune to Ayodhya Taxi Booking",
description: "Pune to Ayodhya taxi booking offers convenient booking options for travelers. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi from Pune to Ayodhya easily."
},
{
name: "Pune to Ayodhya Long Distance Cab",
description: "Pune to Ayodhya long distance cab offers reliable travel for extended journeys. Customers can book cabs for multi-day trips. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with long-distance cab services."
},
{
name: "Pune to Ayodhya Outstation Cab",
description: "Pune to Ayodhya outstation cab provides dependable travel for intercity journeys. Customers can book cabs for one-way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with outstation cab services."
},
{
name: "Pune to Ayodhya Trip Package",
description: "Pune to Ayodhya trip package offers complete travel planning for pilgrims. Customers can enjoy comfortable and organized trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book trip packages from Pune to Ayodhya easily."
},
{
name: "Pune to Ayodhya Family Tour Package",
description: "Pune to Ayodhya family tour package provides comfortable travel for family groups. Customers can enjoy spacious vehicles and safe journeys. Professional drivers ensure smooth travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with family tour packages."
},
{
name: "Pune to Ayodhya Group Tour Package",
description: "Pune to Ayodhya group tour package offers travel solutions for large groups. Customers can book tempo travellers or buses. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with group tour packages from Pune."
},
{
name: "Pune to Ayodhya Round Trip Cab",
description: "Pune to Ayodhya round trip cab provides convenient two-way travel options. Customers can plan return journeys with ease. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures value for money. Book round trip cabs from Pune to Ayodhya."
},
{
name: "Pune to Ayodhya Cab Online Booking",
description: "Pune to Ayodhya cab online booking offers instant reservation options. Customers can book cabs digitally with ease. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab online from Pune to Ayodhya."
},
{
name: "Pune to Ayodhya Taxi Online Booking",
description: "Pune to Ayodhya taxi online booking provides quick and convenient booking services. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily from Pune."
},
{
name: "Pune to Ayodhya Pilgrimage Tour",
description: "Pune to Ayodhya pilgrimage tour offers spiritual travel for devotees. Customers can visit sacred temples comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with pilgrimage tours from Pune."
},
{
name: "Innova Cab Pune to Ayodhya Tour",
description: "Innova cab Pune to Ayodhya tour offers premium SUV travel for long journeys. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures value for money. Travel comfortably with Innova cab services."
}
],

tableData: [
["Pune to Ayodhya Cab","Pune to Ayodhya Tour Package"],
["Pune to Ayodhya Cab Package","Pune to Ayodhya Taxi Package"],
["Pune to Ayodhya Tour by Cab","Pune to Ayodhya Travel Package"],
["Pune to Ayodhya Darshan Package","Pune to Ayodhya Ram Mandir Tour Package"],
["Pune to Ayodhya Cab Service","Pune to Ayodhya Taxi Service"],
["Pune to Ayodhya Cab Booking","Pune to Ayodhya Taxi Booking"],
["Pune to Ayodhya Long Distance Cab","Pune to Ayodhya Outstation Cab"],
["Pune to Ayodhya Trip Package","Pune to Ayodhya Family Tour Package"],
["Pune to Ayodhya Group Tour Package","Pune to Ayodhya Round Trip Cab"],
["Pune to Ayodhya Cab Online Booking","Pune to Ayodhya Taxi Online Booking"],
["Pune to Ayodhya Pilgrimage Tour","Innova Cab Pune to Ayodhya Tour"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Tour Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in Pune to Ayodhya routes, ensuring safe highway driving, proper rest stops, and smooth multi-day travel."
  },
  {
    WhyChooseheading: "Affordable Ayodhya Tour Package Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Ayodhya tour packages with transparent pricing. Customers receive complete fare details including tolls, state taxes, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "Customized Multi-Day Travel Plans",
    WhyChoosedescription: "SRS Cab Service offers flexible Pune to Ayodhya tour packages with customizable itineraries, including stops at religious and tourist destinations along the route."
  },
  {
    WhyChooseheading: "24/7 Tour Cab Service Availability",
    WhyChoosedescription: "Our Pune to Ayodhya cab service operates 24/7, making it convenient for long-distance travel planning, early departures, and comfortable multi-day journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Tours",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort, ensuring a peaceful journey to Ayodhya."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for families, groups, and pilgrimage tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Religious Tour Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Ayodhya tour bookings due to reliable service, experienced drivers, and comfortable travel for spiritual journeys."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Ayodhya tour package?", answer: "Yes, SRS Cab Service offers complete Pune to Ayodhya tour packages with cab and travel planning." },
  { question: "How far is Ayodhya from Pune?", answer: "The distance between Pune and Ayodhya is approximately 1400 km and the journey takes around 24 to 26 hours by road." },
  { question: "How many days are required for Ayodhya tour?", answer: "Typically, a 4 to 6-day trip is recommended for a comfortable Pune to Ayodhya tour package." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible long-distance travel planning." },
  { question: "Which vehicles are available for Ayodhya tour?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize my Ayodhya tour package?", answer: "Yes, we provide fully customizable travel plans based on your itinerary and duration." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the tour package online?", answer: "Yes, you can easily book Pune to Ayodhya tour package online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Sharma",
    feedback:
      "Booked SRS Cab Service for Ayodhya tour. Long journey was very comfortable and driver was very supportive.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Verma",
    feedback:
      "Excellent Pune to Ayodhya tour package. Smooth travel and well-managed trip for our family pilgrimage.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ayodhya Tour Package | SRS Cab",
  "description": "SRS Cab offers Pune to Ayodhya tour packages and cab services including one-way, round trips, outstation trips, and family packages. Travel safely and comfortably for Ayodhya Darshan, Ram Mandir tours, and long-distance trips with affordable fares and 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Pune to Ayodhya Tour Package | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Ayodhya tour packages with SRS Cab. One-way, round trips, outstation trips, and family packages for Ayodhya Darshan, Ram Mandir tours, and long-distance travel. Safe, comfortable rides with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoayodhyatourpackage;